import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import * as Sentry from "@sentry/react";
import Button from "../../../../shared/button/Button";
import Sending from "../../../../shared/loaders/Sending";
import ModalThankYou from "../../../../shared/loaders/ModalThankYou";
import {
  Form,
  Label,
  Field,
  TextInput,
  ButtonsWrapper,
  Error,
} from "../styles/interview-styles";

class Decline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formLoading: false,
      successMessageActive: false,
      message: "",
      errors: null,
    };
  }

  showSuccessMessage = () => {
    this.setState({ successMessageActive: true });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });
    const { message } = this.state;
    const { cardData, closeActionModalAfterSubmit, fetchKanbanData } =
      this.props;
    const { updateStatusLink } = cardData;
    const url = updateStatusLink;

    const formData = new FormData();

    formData.append("application_action[action]", "declined_interview");
    formData.append("application_action[message]", message);
    formData.append("application_action[action_at]", Date.now());

    const payload = {
      url,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    };

    axios(payload)
      .then(() => {
        this.setState({ formLoading: false, errors: null });
        this.showSuccessMessage();
        setTimeout(() => {
          closeActionModalAfterSubmit();
          fetchKanbanData({ loading: false, updating: true });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data.errors,
          formLoading: false,
        });
        Sentry.captureException(error);
      });
  };

  handleMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  render() {
    const { errors, message, successMessageActive, formLoading } = this.state;
    const { candidate, handleCancel } = this.props;

    return (
      <Fragment>
        {formLoading && <Sending white />}
        {successMessageActive && (
          <ModalThankYou text="Candidate withdrawn successfully" />
        )}
        <Form onSubmit={this.handleSubmit} decline>
          <Label className="animated fadeInUp delay-1">
            You&apos;re about to <strong>withdraw</strong>{" "}
            <strong>{candidate}</strong>. <br /> Please let the employer know
            why you&apos;re withdrawing your candidate.
          </Label>
          <Field className="animated fadeInUp delay-2">
            <TextInput
              error={errors && errors.message}
              value={message}
              placeholder="Please add your message..."
              onChange={this.handleMessage}
            />
            {errors && errors.message && (
              <Error className="animated bounceIn">
                Message {errors.message}.
              </Error>
            )}
          </Field>
          <ButtonsWrapper className="animated fadeInUp delay-3">
            <Button
              secondary
              buttonName="Cancel"
              onClickAction={handleCancel}
            />
            <Button primary buttonName="Withdraw Candidate" type="submit" />
          </ButtonsWrapper>
        </Form>
      </Fragment>
    );
  }
}

Decline.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  candidate: PropTypes.string.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  interviewType: PropTypes.string.isRequired,
};

export default Decline;
